import '../../i18n/autoTranslate';
// [NEW] MetricCardsSkeletonRow.jsx
// Used during initial dashboard load (replaces static placeholders).

import React from "react";

const SkeletonBlock = ({ className = "" }) => (
  <div className={`animate-pulse rounded-xl bg-white/10 ${className}`} />
);

function MetricCardSkeleton() {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-4 shadow-[0_14px_50px_rgba(0,0,0,0.25)]">
      {/* soft glow */}
      <div className="pointer-events-none absolute -top-16 -right-16 h-40 w-40 rounded-full bg-purple-500/10 blur-3xl" />

      <div className="relative z-10 space-y-3">
        <div className="flex items-center justify-between">
          <SkeletonBlock className="h-4 w-24" />
          <SkeletonBlock className="h-10 w-10 rounded-2xl" />
        </div>

        <SkeletonBlock className="h-8 w-20" />

        <div className="space-y-2">
          <SkeletonBlock className="h-3 w-[90%]" />
          <SkeletonBlock className="h-3 w-[70%]" />
        </div>

        <div className="mt-2 flex items-center gap-2">
          <SkeletonBlock className="h-5 w-16 rounded-full" />
          <SkeletonBlock className="h-5 w-20 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export default function MetricCardsSkeletonRow({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <MetricCardSkeleton key={i} />
      ))}
    </div>
  );
}
